<!-- appBodyPortal: tira o overlay do ion-content (contexto de empilhamento com z-index 0),
     senão o backdrop não cobre a barra de abas e o card disputa com o chrome da página -->
<div appBodyPortal>
<ng-container *ngIf="coupon">
	<!-- Pop-up (design "cupom em destaque": resgatar joga o cupom para o carrinho) -->
	<ng-container *ngIf="open">
		<div class="fc-backdrop" (click)="closePopup()"></div>
		<div class="fc-center">
			<div class="fc-card" data-cy="featuredCouponPopup">
				<div class="fc-card__emoji">🎉</div>
				<button class="fc-card__close" (click)="closePopup()" aria-label="Fechar">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round">
						<path d="M6 6l12 12M18 6L6 18"></path>
					</svg>
				</button>
				<div class="fc-card__title">Parabéns!</div>
				<div class="fc-card__subtitle">Você ganhou {{ discountSentence() }}:</div>
				<div class="fc-card__code-box">
					<div class="fc-card__code">{{ coupon.code }}</div>
				</div>
				<button class="fc-card__redeem" *ngIf="!redeemed" (click)="redeem()" data-cy="featuredCouponRedeem">Resgatar cupom</button>
				<!-- Confirmação do resgate (doc Cupons 3.0 telas do cliente, 3.3): substitui o
				     botão no MESMO card e NÃO fecha sozinha. -->
				<div class="fc-card__redeemed" *ngIf="redeemed" data-cy="featuredCouponRedeemed">
					<span class="fc-card__check">
						<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
							<path d="M20 6 9 17l-5-5"></path>
						</svg>
					</span>
					<span class="fc-card__redeemed-text">
						<span class="fc-card__redeemed-title">Cupom resgatado!</span>
						<span class="fc-card__redeemed-sub">Ele será aplicado quando você finalizar o pedido.</span>
					</span>
				</div>
				<!-- Restrição principal, discreta no rodapé do card; permanece após o resgate
				     (é ela que explica por que o cupom ainda não entrou no pedido). -->
				<div class="fc-card__rule" *ngIf="ruleSentence()" data-cy="featuredCouponRule">{{ ruleSentence() }}</div>
			</div>
		</div>
	</ng-container>

	<!-- Fechado: botão flutuante para reabrir. SÓ na tela inicial do cardápio (doc 3.4):
	     as rotas empilhadas (pizza/extra) e as outras tabs ficam sem ele. Com o carrinho
	     flutuante full-width do fluxo novo visível, a pílula sobe para não cobri-lo. -->
	<button
		class="fc-pill"
		*ngIf="!open && onMenuHome"
		[class.fc-pill--above-cart]="cartBarVisible"
		[class.fc-pill--above-cashback]="cashbackChipVisible"
		(click)="openPopup()"
		data-cy="featuredCouponPill"
	>
		<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
			<path d="M9 11l-4 4v-4"></path>
			<path d="M20 4L4 20"></path>
			<circle cx="7.5" cy="7.5" r="2.5"></circle>
			<circle cx="16.5" cy="16.5" r="2.5"></circle>
		</svg>
		Ver cupom
	</button>
</ng-container>
</div>
